import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px","margin-top":"4px"}
}, "建议尺寸: 320 x 320 px (1:1 方图)", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.compound_category,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.compound_category.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.compound_category.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "图片" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              class: "avatar-uploader",
              action: "https://jsonplaceholder.typicode.com/posts/",
              "show-file-list": false,
              "auto-upload": false,
              ref: "uploadRef",
              "on-change": _ctx.onChange
            }, {
              default: _withCtx(() => [
                (_ctx.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.imageUrl,
                      class: "avatar"
                    }, null, 8, _hoisted_2))
                  : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      class: "avatar-uploader-icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_plus)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["on-change"]),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "排序" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.compound_category.sorting,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.compound_category.sorting) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "合成类型",
          prop: "compound_type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.compound_category.compound_type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.compound_category.compound_type) = $event)),
              placeholder: "请选择合成类型"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "商品",
                  value: "product"
                }),
                _createVNode(_component_el_option, {
                  label: "卡牌",
                  value: "card"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "启用" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.compound_category.enabled,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.compound_category.enabled) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}